import Path from "../../services/paths";
import BaselineTotalDemandActions from "../actions/baselineTotalDemandActions";
import utils from "../common/utils";
import axios from "axios";

class BaselineTotalDemandMiddleware {
    static getBaselineTotalDemand(
        selectedCategory,
        selectedBrand,
        selectedSku

    ) {
        let url = `${Path.BASELINE_TOTAL_DEMAND}?`;
        if (selectedCategory) {
            url += `category=${selectedCategory}&`;
        }
        if (selectedBrand) {
            url += `brand=${selectedBrand}&`;
        }
        if (selectedSku) {
            url += `master_sku=${selectedSku}&`;
        }

        url = url.slice(0, -1);

        return dispatch => {
            dispatch(BaselineTotalDemandActions.baselineTotalDemandRequest());

            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.status === 200) {
                                dispatch(BaselineTotalDemandActions.baselineTotalDemandSuccessul(res));
                            }
                            else{
                                dispatch(BaselineTotalDemandActions.baselineTotalDemandFailed('error'));
                            }
                        })
                        .catch(error => {
                            dispatch(BaselineTotalDemandActions.baselineTotalDemandFailed(error));
                        });
                })
                .catch(error => {
                    dispatch(BaselineTotalDemandActions.baselineTotalDemandFailed(error));
                });
        };
    }


    //******** BASE LINE TOTAL DEMAND TIME LINE *********
    static getBaselineTotalDemandTimeLine(
        selectedCategory,
        selectedBrand,
        selectedSku

    ) {
        let url = `${Path.BASELINE_TOTAL_DEMAND_TIME_LINE}?`;
        if (selectedCategory) {
            url += `category=${selectedCategory}&`;
        }
        if (selectedBrand) {
            url += `brand=${selectedBrand}&`;
        }
        if (selectedSku) {
            url += `master_sku=${selectedSku}&`;
        }

        url = url.slice(0, -1);

        return dispatch => {
            dispatch(BaselineTotalDemandActions.baselineTotalDemandTimeLineRequest());

            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.status === 200) {
                                dispatch(BaselineTotalDemandActions.baselineTotalDemandTimeLineSuccessul(res));
                            }
                            else{
                                dispatch(BaselineTotalDemandActions.baselineTotalDemandTimeLineFailed('error'));
                            }
                        })
                        .catch(error => {
                            dispatch(BaselineTotalDemandActions.baselineTotalDemandTimeLineFailed(error));
                        });
                })
                .catch(error => {
                    dispatch(BaselineTotalDemandActions.baselineTotalDemandTimeLineFailed(error));
                });
        };
    }
}

export default BaselineTotalDemandMiddleware;
